import { render, staticRenderFns } from "./TaxRules.vue?vue&type=template&id=2dac4bf4"
import script from "./TaxRules.vue?vue&type=script&lang=js"
export * from "./TaxRules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports